import {Button, Select, styled, Tabs, Tab} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledTopicSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.dark,
}));

export const StyledTopicTabs = styled(Tabs)(({theme}) => ({
  width: '100%',
  backgroundColor: theme.palette.background.grey,
  borderRadius: theme.shape.borderRadiusFull,
  padding: theme.spacing(0.5, 0.5),
  marginBottom: theme.spacing(2),

  // container for the buttons
  '& .MuiTabs-flexContainer': {
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },

  // remove the underline indicator
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

export const StyledTopicTab = styled(Tab)(({theme}) => ({
  textTransform: 'none',
  minHeight: 40,
  borderRadius: theme.shape.borderRadiusFull,
  padding: theme.spacing(0, 4),
  color: theme.palette.text.dark,
  fontSize: theme.typography.tabs.fontSize,

  // remove MUI's ripple "click" effect
  '& .MuiTouchRipple-root': {
    display: 'none',
  },

  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.15)',
  },

  '&.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.background.activeTab,
  },

  '&.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.text.dark}`,
    outlineOffset: 2,
  },

  '&.Mui-selected.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.common.white}`,
    outlineOffset: 2,
  },
}));

export const StyledTopicSelect = styled(Select)(({theme}) => ({
  width: '100%',
  backgroundColor: theme.palette.background.grey,
  borderRadius: theme.shape.borderRadiusLg,
  color: theme.palette.text.dark,
  fontSize: theme.typography.tabs.fontSize,

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '& .MuiSvgIcon-root': {
    color: theme.palette.text.dark,
  },
}));

export const StyledLoadMoreButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(1.25, 6),
  marginTop: theme.spacing(4),

  '&:hover': {
    backgroundColor: '#C8001F',
  },

  '&.Mui-disabled': {
    backgroundColor: theme.palette.primary.main,
    opacity: 0.7,
    color: theme.palette.primary.contrastText,
  },
}));
